export enum WindowStatus {
  Normal,
  Maximized,
  Fullscreen
}
